//deps
import React, { memo, useMemo, ReactElement } from "react";

// helpers
import { AriaHidden, getAddressInfo } from "@swiggy-private/core-ui";

// constants
import { UNSERVICEABLE_CART_WIDGET_DATA } from "@cart-ui/constants/TextDict";

//components
import { ActionButton, ActionsSection, Container, ContainerMeta, MetaTextWrapper, SubTitleText } from "../styled";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";
import { default as ErrorFilledIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/errorFilled/20";

//types and interfaces
import { UserAddress } from "@swiggy-private/cart-types";

export interface UnServiceableCartFooterProps {
    selectedAddress?: UserAddress;
    onChangeAddress: VoidFunction;
    onViewSimilarRestaurant: VoidFunction;
}

function UnServiceableCartFooter(props: UnServiceableCartFooterProps): ReactElement {
    const addressInfo = useMemo(() => getAddressInfo(props.selectedAddress), [props.selectedAddress]);
    return (
        <Container>
            <ContainerMeta>
                <AriaHidden as="div">
                    <GenericIcon Icon={ErrorFilledIcon} fillColor="negative" strokeColor="negative" />
                </AriaHidden>
                <MetaTextWrapper>
                    <Text variant="V2.subheading1.neutral.black" color="text_High_Emphasis">
                        {UNSERVICEABLE_CART_WIDGET_DATA.TITLE}
                    </Text>
                    {props.selectedAddress && (
                        <SubTitleText variant="V2.body3.neutral.regular" color="text_Med_Emphasis">
                            {addressInfo}
                        </SubTitleText>
                    )}
                </MetaTextWrapper>
            </ContainerMeta>
            <ActionsSection>
                <ActionButton
                    onClick={props.onChangeAddress}
                    variant="fullwidth"
                    buttonType="secondary"
                    buttonSize="large"
                >
                    {UNSERVICEABLE_CART_WIDGET_DATA.CHANGE_ADDRESS}
                </ActionButton>
                <ActionButton
                    onClick={props.onViewSimilarRestaurant}
                    variant="fullwidth"
                    buttonType="primary"
                    buttonSize="large"
                >
                    {UNSERVICEABLE_CART_WIDGET_DATA.VIEW_SIMILAR}
                </ActionButton>
            </ActionsSection>
        </Container>
    );
}

export default memo(UnServiceableCartFooter);
